Bingo.PropertySpecification = {};

Bingo.PropertySpecification.init = function () {
    toggleYesNoRadio = function (name, blockId) {
        if ($(`input[name='${name}']`).length > 0) {
            const value = $(`input[name='${name}']:checked`).val();
            const toggleBlock = $(`#${blockId}`);
            if (value === 'yes') {
                toggleBlock.show();
            } else {
                toggleBlock.hide();
            }
        }
    };

    // Balcony
    $("input[name='has_balcony']").on('click', () => {
        toggleYesNoRadio('has_balcony', 'switch-balcony-size');
    });
    toggleYesNoRadio('has_balcony', 'switch-balcony-size');

    // Terrace
    $("input[name='has_terrace']").on('click', () => {
        toggleYesNoRadio('has_terrace', 'switch-terrace-size');
    });
    toggleYesNoRadio('has_terrace', 'switch-terrace-size');

    // Land area
    $("input[name='has_land_area']").on('click', () => {
        toggleYesNoRadio('has_land_area', 'switch-land-area');
    });
    toggleYesNoRadio('has_land_area', 'switch-land-area');
};
